import { Stack } from 'libs/ui';

import { useOrderContext } from '../../providers/OrderProvider';
import { OrderFormActions, OrderFormActionsProps } from '../OrderFormActions';
import { OrderHeader } from '../OrderHeader';

export interface OrderFormHeaderProps
  extends Omit<OrderFormActionsProps, 'orderType' | 'order'> {
  title: string;
}

export const OrderFormHeader = ({
  title,
  ...actionsProps
}: OrderFormHeaderProps) => {
  const { order } = useOrderContext();

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing={24}
    >
      <OrderHeader orderStatus={order?.status} title={title} />
      <OrderFormActions {...actionsProps} />
    </Stack>
  );
};
